module.exports = __webpack_public_path__ + "img/footer_logo2.b524820b.jpg";